import { SALES_API_BASE_URL } from "app/pages/sales-intelligence/constants/api";
import type { IFetchService } from "app/services/fetchService";

import { SALESLOFT_CADENCES_PAGE_SIZE } from "../../constants/salesloftConstants";
import type { SalesloftCadencesResponse } from "../../types/salesloft.types";

type CadenceVisibility = "All" | "Private" | "Shared";

export type FetchCadencesParams = {
    page: number;
    pageSize?: number;
    visibility?: CadenceVisibility;
    name?: string;
    includeSteps?: boolean;
};

type SalesloftCadencesApiQuery = {
    page: number;
    pageSize: number;
    visibility: CadenceVisibility;
    includeSteps: boolean;
    name?: string;
};

export type SalesloftApiService = {
    fetchCadences(params: FetchCadencesParams): Promise<SalesloftCadencesResponse>;
};

const SALESLOFT_BASE_URL = `${SALES_API_BASE_URL}/salesloft`;

const createSalesloftApiService = (fetchService: Readonly<IFetchService>): SalesloftApiService => {
    return {
        fetchCadences(params) {
            const trimmedName = params.name?.trim();

            const queryParams: SalesloftCadencesApiQuery = {
                page: params.page,
                pageSize: params.pageSize ?? SALESLOFT_CADENCES_PAGE_SIZE,
                visibility: params.visibility ?? "All",
                includeSteps: params.includeSteps ?? true,
                ...(trimmedName ? { name: trimmedName } : {}),
            };

            return fetchService.get<SalesloftCadencesResponse>(`${SALESLOFT_BASE_URL}/cadences`, queryParams);
        },
    };
};

export default createSalesloftApiService;
